import React from 'react';
import PropTypes from 'prop-types';

import SplitShipModalContextProvider from './split-ship-modal-context-provider';
import { SplitShipSessionProvider } from './event-tracking/split-ship-session-context';
import { MissingLinksErrorModal } from './missing-links-error-modal';
import { SplitShipModalContent } from './split-ship-modal-content';

import { useInitializeSplitShipModal } from './use-initialize-split-ship-modal';
import { useEntitiesSalesOrder } from '../../hooks/entities/selectors/sales-orders';

export const SplitShipModal = ({ onClose, salesOrderId }) => {
  const salesOrder = useEntitiesSalesOrder(salesOrderId);

  const {
    key, // this 'key' value is used to remount the ContextProvider
    // in the edge case where the first 'initialTableData' that this hook returns
    // needs updating via an API call. In order to ensure the ContextProvider
    // initializes its 'tableData' state variable with the second 'initialTableData',
    // we change the value of 'key' which tells React to unmount then remount the component
    // — which is the same way keys are used for Array.map-rendered components.
    isInitializing,
    hasError,
    initialFulfillmentPlans,
    initialTableData,
  } = useInitializeSplitShipModal(salesOrder.fulfillmentPlanIds);

  if (hasError) {
    return <MissingLinksErrorModal onClose={onClose} />;
  }

  return (
    <SplitShipModalContextProvider
      key={key}
      closeModal={onClose}
      initialFulfillmentPlans={initialFulfillmentPlans}
      initialTableData={initialTableData}
      salesOrderId={salesOrderId}
    >
      <SplitShipSessionProvider>
        <SplitShipModalContent isInitializing={isInitializing} onClose={onClose} salesOrderId={salesOrderId} />
      </SplitShipSessionProvider>
    </SplitShipModalContextProvider>
  );
};

SplitShipModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  salesOrderId: PropTypes.string.isRequired,
};
